import React, { useContext, useState } from "react"
import PropTypes from 'prop-types'
import Select from './Select'
import { SEARCH, SearchContext } from "../SearchContext"

const options = Array.from({ length: 19 }, (_, i) => {
  return {value: `${i}`, label: `${i}`}
})

const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const filterOptions = (candidate, input) => {
  const escapedValue = escapeRegexCharacters(input.trim())
  const regex = new RegExp('\\b' + escapedValue, 'i')
  if (input) {
    return regex.test(candidate.value)
  }
  return true
}

const AgeField = ({index, roomIdx}) => {

  const { state: { childrenAges, roomsData }, dispatch } = useContext(SearchContext)
  const _setChildrenAges = (payload) => dispatch({ type: SEARCH.CHILDREN_AGES.SET, payload })

  const _handleChange = (selected, action) => {
    let age = parseInt(selected.value)

    let newRoomAges = [...childrenAges[roomIdx]]
    newRoomAges[index] = age

    let newChildrenAges = { ...childrenAges, [roomIdx]: newRoomAges }
    _setChildrenAges(newChildrenAges)
  }

  const _getValue = () => {
    if (childrenAges[roomIdx] && childrenAges[roomIdx][index]) {
      return options.find((option) => (
        option['value'] == childrenAges[roomIdx][index].toString()
      ))
    } else {
      return ''
    }
  }

  return (
    <div className="kids-age">
      <label className="children-ages" title={`Child #${index + 1} Age`} htmlFor="age">
        <span>Child #{index + 1} Age</span>
        <Select
          name          = "age"
          value         = {_getValue()}
          options       = {options}
          defaultValue  = {options[0]}
          filterOption  = {filterOptions}
          handleChange  = {_handleChange}
          placeholder   = "age"
        />
      </label>
    </div>
  )
}

AgeField.propTypes = {
  index: PropTypes.number.isRequired
}

export default AgeField
